// extracted by mini-css-extract-plugin
export var settingsList = "_3l-0";
export var settingsRow = "_3l-1";
export var warningDot = "_3l-2";